import { Chip, Theme, styled } from '@mui/material'
import MuiDivider, { DividerProps as MuiDividerProps } from '@mui/material/Divider'
import { SystemCssProperties } from '@mui/system'
import { FC, ReactNode } from 'react'

interface DividerProps extends Omit<MuiDividerProps, 'color'> {
  color?: SystemCssProperties<Theme>['borderColor']
  label?: ReactNode
}

const Divider: FC<DividerProps> = ({ color = 'grey.200', label, sx, ...props }) => (
  <StyledDivider sx={{ ...sx, borderColor: color }} {...props}>
    {label && (
      <Chip
        size="small"
        label={label}
        sx={{ color: (theme) => theme.palette.grey[600] }}
        variant="outlined"
      />
    )}
  </StyledDivider>
)

const StyledDivider = styled(MuiDivider)`
  & .MuiDivider-wrapper {
    padding-left: 0;
    padding-right: 0;

    & .MuiChip-root {
      color: ${({ theme }) => theme.palette.grey[600]};
      border: 1px solid ${({ theme }) => theme.palette.grey[300]};
      box-shadow: 0 0 3px 1px ${({ theme }) => theme.palette.grey[200]};
    }
  }
`

export default Divider
